<template>
  <v-main>
    <!--Background-->
    <div class="login-background">
      <video autoplay loop muted :poster="require('@/assets/img/3.png')">
        <source src="https://d2bt60lg5oycgc.cloudfront.net/30/driblab-login-intro-video.mp4" type="video/mp4">
      </video>
    </div>
    <v-container fluid class="fill-height pt-10">
      <v-row style="z-index: 1">
        <v-col cols="12" class="d-flex flex-column align-center justify-center">
          <v-img
            max-width="300px"
            class="white--text my-10"
            :src="require('@/assets/img/driblab_white_box_pro.png')"
          ></v-img>
          <MaterialCard :color="$vuetify.theme.dark ? 'secondary' :  'brandDark'" class="mt-10" width="450px">
            <template v-slot:heading>
              <h2 class='white--text header-font' align="center">{{$t('login.resetPassword')}}</h2>
            </template>
            <v-container fluid>
              <v-form name="form" ref="formRef" @submit.prevent="onSaveClick">
                <v-card-text class="pa-0">
                  <p class="body-1 font-weight-bold primary--text pb-1 mb-0">{{$t("login.password")}}</p>
                  <v-text-field dense outlined
                    @change="onInputChange()"
                    @keydown.enter="onSaveClick()"
                    v-model="user.password"
                    ref="passwordRef"
                    :rules="passwordRules"
                    type="password"
                    prepend-inner-icon="lock"
                  ></v-text-field>
                  <p class="body-1 font-weight-bold primary--text pb-1 mb-0">{{$t("login.passwordConfirmation")}}</p>
                  <v-text-field dense outlined
                    @change="onInputChange()"
                    @keydown.enter="onSaveClick()"
                    v-model="user.passwordConfirmation"
                    ref="passwordConfirmationRef"
                    :rules="passwordConfirmationRules"
                    type="password"
                    prepend-inner-icon="lock"
                  ></v-text-field>
                </v-card-text>

                <v-card-actions class="justify-center px-0 pb-1">
                  <v-btn
                    type="submit" rounded
                    :loading="loading"
                    class="elevation-0 monospace-font white--text"
                    :color="$vuetify.theme.dark ? 'secondary' : 'brandBlue'"
                    block
                  >{{ $t('general.save') }}</v-btn>
                </v-card-actions>

                <v-spacer></v-spacer>
              </v-form>
            </v-container>
          </MaterialCard>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import MaterialCard from "./base/MaterialCard";
import Dictionary from "../dictionary";
import AuthService from "../services/auth.service";

export default {
  name: "ResetPassword",
  components: {
    MaterialCard
  },
  data() {
    return {
      user: {},
      passwordRules: [
        v =>
          !!v ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"],
        v =>
          _.size(v) >= 8 ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["minLength"] +
            " (8)"
      ],
      passwordConfirmationRules: [
        v =>
          !!v ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["required"],
        v =>
          v === this.user.password ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"][
            "passwordMatch"
          ],
        v =>
          _.size(v) >= 8 ||
          Dictionary[this.$i18n.locale]["general"]["formErrors"]["minLength"] +
            " (8)"
      ],
      loading: false
    };
  },
  methods: {
    onInputChange() {
      this.$refs.formRef.validate();
    },
    async onSaveClick() {
      if (!this.$refs.formRef.validate()) return;
      this.loading = true;
      try {
        const passwordResponse = await AuthService.updatePassword(
          this.user,
          this.$route.params.token
        );
        const data = passwordResponse.data;
        const success =
          typeof data === "number" ||
          (typeof data === "string" &&
            data !== "" &&
            !Number.isNaN(Number(data)));
        if (success) {
          this.$store.dispatch("changeToast", {
            showToast: true,
            text: "general.successMessage",
            outlined: false,
            color: "success darken-1",
            icon: "check_circle"
          });
          this.$router.push("/login");
        } else {
          this.$store.dispatch("changeToast", {
            showToast: true,
            text: "general.failMessage",
            outlined: false,
            color: "error darken-1",
            icon: "sms_failed"
          });
        }
      } catch (err) {
        const status = err.response && err.response.status;
        if (status === 400) {
          this.$store.dispatch("changeToast", {
            showToast: true,
            text: "login.resetPasswordLinkInvalid",
            outlined: false,
            color: "error darken-1",
            icon: "sms_failed"
          });
        } else {
          this.$store.dispatch("changeToast", {
            showToast: true,
            text: "general.failMessage",
            outlined: false,
            color: "error darken-1",
            icon: "sms_failed"
          });
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.login-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.login-background video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue